/* eslint-disable react/prop-types */
import React, { useLayoutEffect, useRef, useState } from 'react';

import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  accDetails: {
    paddingLeft: 6,
    height: 19,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: theme.palette.text.secondary,
  },
  cell: {
    margin: '0 1%',
    borderBottom: 'none',
    display: 'flex',

    '&:first-child': {
      marginLeft: '0px',
    },
    '&:last-child': {
      marginLeft: '0px',
    },
  },
}));

const getMaskedNumberForInfo = (number) => {
  if (!number) {
    return '';
  }
  const charactersNum = number.length >= 4 ? 4 : number.length;
  const lastCharacters = number && number.slice(-charactersNum);
  const last4Characters =
    lastCharacters && !Number.isNaN(Number(lastCharacters)) ? 'X'.repeat(4 - charactersNum) + lastCharacters : 'XXXX';
  return ` ••••${last4Characters}`;
};

const AccountRow = (props) => {
  const { name, type, cpName, cpNumber } = props;

  const nameRef = useRef();
  const [showNameTip, setShowNameTip] = useState();

  const { classes } = useStyles();

  let additionalNameInfo = name !== cpName ? cpName : '';
  additionalNameInfo += getMaskedNumberForInfo(cpNumber);

  useLayoutEffect(() => {
    setShowNameTip(nameRef.current && nameRef.current.offsetWidth < nameRef.current.scrollWidth);
  }, []);

  return (
    <Box display='flex' flex='1' mb={1}>
      <Box display='flex' maxWidth='2%' className={classes.cell}>
        &bull;
      </Box>
      <Box flexBasis='49%' maxWidth='30%' className={classes.cell} style={{ overflow: 'hidden' }}>
        <Box display='flex' flex='1' flexDirection='column' style={{ overflow: 'hidden' }}>
          <Tooltip title={showNameTip ? name : ''}>
            <Typography variant='paragraphRegular' noWrap ref={nameRef}>
              {name}
            </Typography>
          </Tooltip>
          <Typography variant='captionRegular' className={classes.accDetails}>
            {additionalNameInfo}
          </Typography>
        </Box>
      </Box>
      <Box flexBasis='23%' maxWidth='20%' className={classes.cell}>
        <Typography variant='paragraphRegular'>{type}</Typography>
      </Box>
      <Box flexBasis='24%' maxWidth='48%' className={classes.cell}>
        &nbsp;
      </Box>
    </Box>
  );
};

export default AccountRow;
